<template>
    <div class="basket">
        <div class="app-container pa-4">
            <breadcrumbs :breadcrumbs="breadcrumbs"></breadcrumbs>
            <v-row class="mx-0">
                <v-col cols="12" sm="12" md="12" lg="8">
                    <div>
                        <v-card outlined>
                            <h1 class="justify-center font-weight-bold subtitle-2 text-uppercase pa-4" v-if="metaData.header">
                                {{ metaData.header }}
                            </h1>
                        </v-card>
                        <v-skeleton-loader type="text" v-if="!metaData.header" class="pa-4 mx-auto" width="40%"></v-skeleton-loader>
                        <div>
                            <order-list></order-list>
                        </div>
                    </div>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="4">
                    <order-amount></order-amount>
                    <v-card class="mt-2" flat outlined>
                        <v-card-title class="justify-center text-center pt-0 pb-2">{{ $t('partners') }}</v-card-title>
                        <v-card-text v-for="partner in partnersInfo" :key="partner.id" class="text-center pt-0 pb-2">
                            <a :href="partner.link" target="_blank" rel="nofollow">
                                <img :src="partner.image" :alt="partner.name" class="partner-img" style="max-width:150px;">
                            </a>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <order-dialog @create-order="send"></order-dialog>
        </div>
        <snack-general :snack-data="snackData"></snack-general>
    </div>
</template>

<script>

    import AppBreadcrumbs from '../../../app-front/mixins/AppBreadcrumbs';
    import Auth from "../../../app-front/mixins/Auth";
    import Breadcrumbs from '../../../app-front/components/breadcrumbs';
    import ProfileDataProvider from "../../../app-front/mixins/ProfileDataProvider";
    import RouteAccess from '../../../app-front/mixins/RouteAccess';

    import Partners from '../../../app-front/mixins/Partners';
    import OrderAmount from './v-2/OrderAmount';
    import OrderDialog from './v-2/OrderDialog';
    import OrderList from './v-2/OrderList';
    import OrderResponse from './v-2/OrderResponse';

    import OrderDataProvider from '../../../app-front/mixins/OrderDataProvider';
    import InfoService from '../../../app-front/services/api/InfoService';
    import BasketService from '../../../app-front/services/api/BasketService';
    import SnackGeneral from '../../../app-front/components/snacks/SnackGeneral';
    import NoLoginBasket from "../../../app-front/mixins/NoLoginBasket";

    export default {
        name: "Basket",
        mixins: [
            AppBreadcrumbs,
            Auth,
            OrderDataProvider,
            Partners,
            ProfileDataProvider,
            NoLoginBasket
            //RouteAccess
        ],
        components:{
            Breadcrumbs,
            OrderAmount,
            OrderDialog,
            OrderList,
            SnackGeneral
        },
        data() {
            return {
                metaUrl: '/basket',
                breadcrumbsData: {
                    page: 'basketPage',
                    data:{}
                },
                snackData: {
                    isOpen: false,
                    color: '',
                    text: ''
                }
            }
        },
        beforeRouteLeave(to, from, next) {
            //this.resetCurrentOrderData();

            next();
        },
        methods: {
            authFailRouteHandle() {
                this.redirectToLogin();
            },
            getCreditGuaranties() {
                if(this.$store.state.baseInfo.creditGuaranties.length) return false;

                InfoService.setLocale(this.$store.state.language.appLanguage);
                InfoService.getCreditGuaranties()
                    .then(res => {
                        this.$store.commit('setValueGeneral', {key: 'baseInfo', name: 'creditGuaranties', value: res.data});
                    })
                    .catch(err => console.log(err))
            },
            send(data) {
                const sendData = {
                    customer: data,
                    orders: this.orderSendData
                };

                BasketService.setLocale(this.$store.state.language.appLanguage);
                BasketService.createBasketOrder(sendData)
                    .then(res => {
                        if(res.data.success.length) {
                            this.snackHandle(this.$t('orderSuccess'), 'main--black', true);
                            this.successHandle(res.data);
                        }

                        if(res.data.errors.length) {
                            this.snackHandle(this.$t('orderError'), 'error', true);
                            console.log(res.data.errors);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            successHandle(resData) {
                this.setOrderResponseData(resData);

                if(resData.success && resData.success.length) {
                    const products = [];

                    resData.success.forEach(item => {
                        item.products.forEach(product => {
                            products.push(product.id);
                        });
                    });
                    products.forEach(id=>{
                        this.deleteProductFromNoLoginBasket(id);
                    })

                    const basketItems = this.basketItems.filter(item => products.indexOf(item.productId) < 0);
                    this.$store.commit('setBasket', basketItems);

                    const orderProducts = this.orderProducts.filter(item => {
                        item.data = item.data.filter(product => products.indexOf(product.id) < 0);

                        return item.data.length;
                    });
                    this.setOrderProducts(orderProducts);

                    const inProcessProducts = this.inProcessProducts.filter(item => {
                        item.products = item.products.filter(product => products.indexOf(product.id) < 0);

                        return item.products.length;
                    });
                    this.setOrderInProcess(inProcessProducts);
                }

                this.resetOrderDialog();
            },
            snackHandle(text, color, isOpen) {
                this.snackData.color = color;
                this.snackData.text = text;
                this.snackData.isOpen = isOpen;
            },
        },
        beforeMount() {
            if(this.isUserLoggedIn) {
                this.setOrderBuyer();
            }
            this.getCreditGuaranties();
        },
        watch: {
            inProcessProducts: {
                handler() {
                    this.backupSet();
                },
                deep: true
            },
            isUserLoggedIn(newValue, oldValue) {
                if (!newValue && oldValue) {
                    this.$router.push('/');
                }
                if(newValue) {
                    this.setOrderBuyer();
                }
            },
        }
    }
</script>
